import React from "react";
import { connect } from "react-redux";
import DynamicForm from "../../../components/dynamicscreens/DynamicForm";
import { TownJson } from "../../../DynamicFormsJson/MastersJSON/Town";

class TownForm extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <>
        <DynamicForm
          formPath={TownJson.formPath}
          screenTitle={TownJson.screenTitle}
          fieldMeta={TownJson.fieldMeta}
          tableColumnsToFilter={TownJson.tableColumnsToFilter}
          apiBaseURL={TownJson.apiBaseURL}
          baseIdColumn={TownJson.baseIdColumn}
          type={0}
          isLog={true}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(TownForm);
